import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppGlobalContext } from 'contexts/GlobalContext';
import useAuth from 'hooks/useAuth';
import fetchPricingData from '../Services/fetchPricingData';
import { getCountryCode } from '../utils/country';

export default function usePricingData() {
	const { mainCountry } = useContext(AppGlobalContext);
	const { accessToken } = useAuth();

	const countryName = mainCountry.pais;

	const countryCode = getCountryCode(countryName);

	const pricingQuery = useQuery({
		queryKey: ['pricing', countryName],
		queryFn: () =>
			fetchPricingData(
				{
					name: countryName,
					code: countryCode,
				},
				accessToken
			),
		staleTime: Infinity,
		retry: false,
		placeholderData: (previousData) => previousData,
	});

	return pricingQuery;
}
